package ru.villawonka.app.presentation.design.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Typography
import androidx.compose.runtime.Composable

@Composable
fun AppTheme(
    isDarkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit,
) {
    MaterialTheme(
        colors = AppColors.getColorScheme(isDarkTheme),
        content = content,
        typography = Typography(
            defaultFontFamily = appFontFamily
        )
    )
}